<template>
  <div class="dialogpage bg pa">
    <div class="bigbox" @touchmove.prevent>
      <div class="box pr">
        <div
          id="main"
          class="result pr"
          :style="{
            backgroundImage: 'url(' + src + ')',
          }"
        >
          <!-- <div class="result_name_box pa">
            <p class="result_despara">{{ mood.despara }}</p>
            <div class="result_name_in">
              <i>{{ mood.zhname }}</i>
            </div>
            <p class="result_despara2">
              {{ mood.despara2 }}
              <span class="result_des_bline pa"></span>
            </p>
          </div> -->
          <!-- 生成海报展示 -->
          <!-- <p class="tip" v-show="tipShow">可长按保存图片</p> -->
          <!-- 遮罩层 -->
          <!-- <div
            class="shade pa"
            v-show="tipShow"
            @click="quxiao"
            @touchmove.prevent
          ></div> -->
          <!-- 装图片盒子 -->
          <!-- <div
            id="resultImg"
            class="resultImg pr dl"
            v-show="showResultImg"
          ></div> -->
        </div>
        <!-- <div class="abox-position pa">
      <a href="#" class="spr download" @click="download"></a>
      <a href="#" class="spr replay" @click="replay"></a>
    </div> -->
        <div class="btn pa dl">
          <div class="on register" @click="closePop"></div>
          <div class="on share" @click="gofb"></div>
        </div>
        <div class="smallfont pa"></div>
        <img
          src="../../assets/images/toast_btn.png"
          alt=""
          class="pagebox_Img"
          @click="closePop"
        />
      </div>
    </div>
  </div>
</template>

<script>
// import html2canvas from "html2canvas";
export default {
  name: "resultPage",
  props: ["allCode"],
  data() {
    return {
      mood: [],
      // showResultImg: false,
      tipShow: false,
      src: "",
      id: "",
    };
  },
  created() {
    this.id = this.$util.getItem("resultBG").tagId;
    this.rander();
  },
  mounted() {},
  methods: {
    gofb() {
      // let that = this;
      // eslint-disable-next-line no-undef
      FB.init({
        appId: 553154342524745,
        status: true,
        xfbml: true,
        version: "v2.9",
      });
      var that = this;
      // eslint-disable-next-line no-undef
      FB.ui(
        {
          display: "popup",
          method: "share",
          href: `https://pre.xiaoma.com.tw/dxz/${this.id}.html?f=${
            this.allCode.inviteCode
          }&c=${this.$util.getChannel(that)}`,
        },
        function (response) {
          console.log(response);
          // if (response && !response.error_message) {
          // alert("Posting completed.");
          // that.$bus.$emit("tips", "Posting completed.");
          // }
          // else {
          //   // alert("Error while posting.");
          //   that.$bus.$emit("tips", "Error while posting.");
          // }
        }
      );
    },
    closePop() {
      this.$emit("closePop");
    },
    rander() {
      console.error("2222");
      this.src = require("../../assets/dialog-images/image/" +
        this.id +
        ".png");
    },
    // replay() {
    //   this.$emit("result");
    // },
    // 判断当前是pc还是移动
    // isMobile() {
    //   let flag = navigator.userAgent.match(
    //     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    //   );
    //   return flag;
    // },
    // download() {
    //   if (this.isMobile) {
    //     console.log("移动");
    //     this.downloadMb();
    //   } else {
    //     console.log("PC");
    //     this.downloPc();
    //   }
    // },
    // PC端保存图片
    // downloPc() {
    //   html2canvas(document.getElementById("main"), {
    //     backgroundColor: "white", //画出来的图片有白色的边框,不要可设置背景为透明色（null）
    //     useCORS: true, //支持图片跨域
    //     scale: 1, //设置放大的倍数
    //   }).then((canvas) => {
    //     //如果你需要下载截图，可以使用a标签进行下载
    //     let a = document.createElement("a");
    //     a.href = canvas.toDataURL("image/pdf");
    //     a.download = "test";
    //     a.click();
    //   });
    // },
    // 移动端保存图片
    // downloadMb() {
    //   this.showResultImg = true;
    //   html2canvas(document.getElementById("main"), {
    //     backgroundColor: "white", //画出来的图片有白色的边框,不要可设置背景为透明色（null）
    //     useCORS: true, //支持图片跨域
    //     scale: 1, //设置放大的倍数
    //   }).then((canvas) => {
    //     let url = canvas.toDataURL("image/png"); // 将canvas转成base64图片格式
    //     document.querySelector(
    //       "#resultImg"
    //     ).innerHTML = `<img src="${url}" alt="海报" height="80%" style='z-index: 100' />`;
    //     this.toast();
    //   });
    // },
    // 长按提示动画
    // toast() {
    //   this.tipShow = true;
    //   let tip = document.getElementsByClassName("tip")[0];
    //   setTimeout(() => {
    //     tip.style.transform = "translate(-50%,0.2rem)";
    //     setTimeout(() => {
    //       tip.style.transform = "translate(-50%,-1rem)";
    //     }, 2000);
    //   }, 500);
    // },
    // 清除遮罩层
    // quxiao() {
    //   this.tipShow = false;
    //   this.showResultImg = false;
    // },
  },
};
</script>

<style lang="less" scoped>
.dialogpage {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 7.5rem;
  height: 100vh;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  // .mask {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   background: rgba(0, 0, 0, 0.7);
  // }
  .bigbox {
    width: 100%;
    height: 100%;
    position: relative;
  }
}
.box {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  .result {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center;
    font-size: 0.3rem;
    .result_name_box {
      bottom: 45%;
      left: 8%;
      width: 2.2rem;
      height: 1.2rem;
      text-align: center;
      .result_despara {
        font-size: 0.2rem;
        color: #fac614;
        background: url("../../assets/dialog-images/music_tips.png") no-repeat;
        background-size: 100% 100%;
        width: 100%;
        height: 0.5rem;
        line-height: 0.6rem;
      }
      .result_name_in {
        background: url("../../assets/dialog-images/Rupee_audio.png") no-repeat;
        background-size: 100% 100%;
        height: 1rem;
        line-height: 0.5rem;
        background-position: 0 -0.54rem;
        i {
          font-weight: bold;
          font-size: 0.3rem;
        }
      }
      .result_despara2 {
        font-size: 0.2rem;
        color: #eaeaea;
        padding-left: 0.1rem;
        text-align: left;
        line-height: 0.3rem;
        .result_des_bline {
          background: url("../../assets/dialog-images/Rupee_des.png") no-repeat;
          background-size: 98% 78%;
          background-position: 0 0px;
          width: 2.4rem;
          height: 0.7rem;
          left: 2%;
        }
      }
    }
    .resultImg {
      width: 100%;
      height: 100%;
      justify-content: center;
    }
    .tip {
      font-size: 0.2rem;
      font-weight: bold;
      color: #000;
      background: #fff;
      text-align: center;
      padding: 0.1rem 0.2rem;
      width: 80%;
      position: absolute;
      left: 50%;
      z-index: 100;
      box-sizing: border-box;
      transform: translate(-50%, -1rem);
      transition: all 0.5s linear;
      border-radius: 0.2rem;
    }
    .shade {
      width: 100%;
      height: 100%;
      background-color: #cfcfcf;
      opacity: 0.6;
      z-index: 99;
    }
  }
  .abox-position {
    width: 0.6rem;
    right: 9%;
    top: 20%;
    .spr {
      background: url("../../assets/dialog-images/spr.png") no-repeat;
      width: 0.6rem;
      height: 0.6rem;
      display: block;
      background-size: 450%;
    }
    .download {
      background-position: -0.67rem -0.67rem;
      margin-bottom: 0.3rem;
    }
    .replay {
      background-position: -1.38rem -0.67rem;
    }
  }
  .btn {
    bottom: 9%;
    left: 50%;
    justify-content: center;
    font-size: 0.3rem;
    transform: translateX(-50%);
    padding: 0 0.5rem;
    box-sizing: border-box;
    width: 100%;

    .register {
      background: url("../../assets/dialog-images/image/save.png") no-repeat;
    }
    .share {
      background: url("../../assets/dialog-images/image/shareFB.png") no-repeat;
    }
    .on {
      width: 37%;
      height: 0.5rem;
      cursor: pointer;
      background-size: contain;
      background-position: center;
    }
  }
  .smallfont {
    bottom: 3%;
    width: 100%;
    height: 0.3rem;
    background: url("../../assets/dialog-images/image/smfont.png") no-repeat;
    background-size: contain;
    background-position: center;
    cursor: pointer;
  }
  .pagebox_Img {
    position: absolute;
    top: 2%;
    right: 6%;
    width: 1.2rem;
    cursor: pointer;
  }
}
</style>